// extracted by mini-css-extract-plugin
module.exports = {"v":"Bopomofo_v__3hz8a"};